// เมนูสำหรับผู้ดูแลระบบ (pos 99)
const adminMenu = [
  { "label": "จัดการบุคลากร",      "link": "/admin/staff",       "icon": "ri-user-settings-line" },
  { "label": "กำหนดสิทธิ์ผู้ใช้", "link": "/admin/permissions", "icon": "ri-shield-keyhole-line" },
  { "label": "จัดการประเภทสิทธิ์", "link": "/admin/positions",   "icon": "ri-key-2-line" },
  { "label": "ตั้งค่าระบบ",         "link": "/admin/settings",    "icon": "ri-settings-3-line" },
];

// เมนูสำหรับผู้บริหาร (pos 90/99)
const executiveMenu = [
  { "label": "Dashboard ผู้บริหาร", "link": "/executive/dashboard", "icon": "ri-dashboard-2-line" },
  { "label": "แฟ้มเสนอพิจารณา", "link": "/exec/memos", "icon": "ri-folder-shield-2-line" },
  { "label": "จดหมายเหตุรายวัน", "link": "/admin-office/daily-log", "icon": "ri-booklet-line" },
];

// เมนูสำหรับครูผู้สอน
const teachingMenu = [
  {
    "label": "วิชา / ห้องที่สอน",
    "link": "/teaching/subject-class",
    "icon": "ri-artboard-line"
  },
  {
    "label": "ตารางสอนของฉัน",
    "link": "/teaching/my-timetable",
    "icon": "ri-table-line"
  },
  {
    "label": "เช็คชื่อนักเรียน",
    "link": "/teaching/attendance",
    "icon": "ri-group-line"
  },
  {
    "label": "หาครูสอนแทน",
    "link": "/teaching/substitute",
    "icon": "ri-user-shared-line"
  },
  {
    "label": "ข้อมูลการเช็คชื่อ",
    "link": "/teaching/manage-attendance",
    "icon": "ri-file-text-line"
  },
  {
    "label": "สถิติการเข้าเรียน",
    "link": "/teaching/attendance-statistic",
    "icon": "ri-bar-chart-2-line"
  },
  {
    "label": "บันทึกผลการเรียน",
    "link": "/teaching/saveGrade",
    "icon": "ri-edit-2-line"
  },
  {
    "label": "ดูแลช่วยเหลือนักเรียน",
    "link": "/teaching/my-care",
    "icon": "ri-heart-add-line"
  }
]

// เมนูสำหรับครูประจำชั้น
const advisorMenu = [
  {
    "label": "Dashboard ห้องเรียน",
    "link": "/advisor/dashboard",
    "icon": "ri-dashboard-3-line"
  },
  {
    "label": "ข้อมูลนักเรียน",
    "link": "/advisor/student-in-advice",
    "icon": "ri-group-line"
  },
  {
    "label": "เช็คชื่อคาบแนะแนว",
    "link": "/advisor/guidance",
    "icon": "ri-compass-3-line"
  },
  {
    "label": "แจ้งลานักเรียน",
    "link": "/advisor/student-leave",
    "icon": "ri-user-unfollow-line"
  },
  {
    "label": "ระบบติดตามนักเรียน",
    "link": "/academic/student-tracking",
    "icon": "ri-radar-line"
  },
  {
    "label": "ผลการเรียนรายวิชา",
    "link": "/advisor/grade",
    "icon": "ri-file-text-line"
  },
  {
    "label": "ผลการเรียนรายบุคคล",
    "link": "/advisor/student-grade",
    "icon": "ri-file-user-line"
  },
  {
    "label": "ใบเกรดรวมในชั้นเรียน",
    "link": "/advisor/class-grade",
    "icon": "ri-folder-user-line"
  },
  {
    "label": "จุดเด่นทางวิชาการ",
    "link": "/advisor/talent",
    "icon": "ri-medal-line"
  },
  {
    "label": "บันทึกคุณลักษณะ",
    "link": "/advisor/desirable",
    "icon": "ri-user-3-line"
  },
  {
    "label": "บันทึกส่วนสูงและน้ำหนัก",
    "link": "/advisor/student-body-mass",
    "icon": "ri-scales-2-line"
  },
  {
    "label": "บันทึกสุขภาพนักเรียน",
    "link": "/advisor/student-health",
    "icon": "ri-heart-pulse-line"
  },
  {
    "label": "แบบ ปพ.ต่างๆ",
    "link": "/advisor/student-document",
    "icon": "ri-file-copy-2-line"
  },
  {
    "label": "ตารางสอนห้องเรียน",
    "link": "/advisor/timetable",
    "icon": "ri-table-line"
  }
]

// Menu for teaching manager
const manageTeachingMenu = [
  {
    "label": "จัดการคาบเรียน",
    "link": "/teaching/manage-period",
    "icon": "ri-time-line"
  },
  {
    "label": "จัดการการสอน",
    "link": "/teaching/manage-teaching",
    "icon": "ri-artboard-line"
  },
  {
    "label": "จัดการตารางสอน",
    "link": "/teaching/timetable-editor",
    "icon": "ri-table-line"
  },
  {
    "label": "ติดตามการสอน",
    "link": "/teaching/teaching-tracking",
    "icon": "ri-file-text-line"
  },
  {
    "label": "มอบหมายครูสอนแทน",
    "link": "/teaching/substitute",
    "icon": "ri-user-shared-line"
  },
  {
    "label": "ครูไม่อยู่ / จัดครูสอนแทน",
    "link": "/teaching/substitute-arrangement",
    "icon": "ri-user-unfollow-line"
  }
]

// Menu for registration department
const registrationMenu = [
    {
    "label": "จัดการห้องเรียน",
    "link": "/registration/manage-classes",
    "icon": "ri-building-2-line"
  },
  {
    "label": "จัดการนักเรียน",
    "link": "/registration/manage-students/1",
    "icon": "ri-group-line"
  },
  {
    "label": "จัดการหลักสูตร",
    "link": "/registration/manage-curriculum",
    "icon": "ri-book-2-line"
  },
  {
    "label": "จัดการรายวิชา",
    "link": "/registration/manage-subjects",
    "icon": "ri-book-open-line"
  }
]

// เมนูสำหรับฝ่ายวัดผลและประเมินผล
const assessmentMenu = [
  {
    "label": "เกรดรวมในชั้นเรียน",
    "link": "/assessment/all-class-grade",
    "icon": "ri-grid-line"
  },
  {
    "label": "ผลสัมฤทธิ์รายวิชา",
    "link": "/assessment/grade-distribution",
    "icon": "ri-bar-chart-grouped-line"
  },
  {
    "label": "ผลการเรียนรายนักเรียน",
    "link": "/assessment/student-grades",
    "icon": "ri-file-user-line"
  },
  {
    "label": "คำร้องสอบแก้ตัว",
    "link": "/assessment/makeup-exam-request",
    "icon": "ri-file-edit-line"
  }
]

// เมนูห้องสมุด (สำหรับผู้ดูแลห้องสมุด)
const libraryMenu = [
  {
    "label": "Dashboard ห้องสมุด",
    "link": "/library/home",
    "icon": "ri-book-3-line"
  },
  {
    "label": "ค้นหาหนังสือ",
    "link": "/library/book-search",
    "icon": "ri-search-2-line"
  },
  {
    "label": "ยืม-คืนหนังสือ",
    "link": "/library/circulation",
    "icon": "ri-arrow-left-right-line"
  },
  {
    "label": "ต่ออายุการยืม",
    "link": "/library/renewals",
    "icon": "ri-history-line"
  },
  {
    "label": "จองหนังสือ",
    "link": "/library/reservations",
    "icon": "ri-bookmark-line"
  },
  {
    "label": "ค่าปรับห้องสมุด",
    "link": "/library/fines",
    "icon": "ri-money-dollar-circle-line"
  },
  {
    "label": "นำเข้าหนังสือ",
    "link": "/library/acquisition",
    "icon": "ri-inbox-archive-line"
  },
  {
    "label": "สร้าง/พิมพ์บาร์โค้ด",
    "link": "/library/barcode-labels",
    "icon": "ri-barcode-line"
  },
  {
    "label": "จัดการข้อมูลหนังสือ/เล่ม",
    "link": "/library/book-management",
    "icon": "ri-book-open-line"
  },
  {
    "label": "จัดการข้อมูลแม่บท",
    "link": "/library/master-data",
    "icon": "ri-database-2-line"
  }
]

// เมนูหอพัก
const dormitoryMenu = [
  {
    "label": "Dashboard หอพัก",
    "link": "/dormitory/home",
    "icon": "ri-building-4-line"
  },
  {
    "label": "จัดการหมู่บ้าน",
    "link": "/dormitory/villages",
    "icon": "ri-community-line"
  },
  {
    "label": "จัดการหอพัก",
    "link": "/dormitory/buildings",
    "icon": "ri-building-2-line"
  },
  {
    "label": "จัดนักเรียนเข้าหอ",
    "link": "/dormitory/allocation",
    "icon": "ri-user-add-line"
  },
  {
    "label": "ย้ายออก/ย้ายหอ",
    "link": "/dormitory/transfer",
    "icon": "ri-arrow-left-right-line"
  },
  {
    "label": "ค้นหาหอว่าง",
    "link": "/dormitory/vacancy",
    "icon": "ri-door-open-line"
  },
  {
    "label": "ค้นหานักเรียนในหอพัก",
    "link": "/dormitory/student-search",
    "icon": "ri-search-eye-line"
  }
]

// เมนูการเงิน / ค่าใช้จ่ายนักเรียน
const feeMenu = [
  {
    "label": "ภาพรวมการเงิน",
    "link": "/fee/home",
    "icon": "ri-money-dollar-circle-line"
  },
  {
    "label": "รายการค่าใช้จ่าย",
    "link": "/fee/items",
    "icon": "ri-price-tag-3-line"
  },
  {
    "label": "งวด/ภาคเรียน",
    "link": "/fee/terms",
    "icon": "ri-calendar-2-line"
  },
  {
    "label": "ตั้งราคาตามชั้น/สาย",
    "link": "/fee/plans",
    "icon": "ri-table-line"
  },
  {
    "label": "ออกบิล / รับชำระ",
    "link": "/fee/invoices",
    "icon": "ri-bill-line"
  }
]

// เมนูงานบุคลากร (HR pos 20, admin 99)
const hrMenu = [
  {
    "label": "ภาพรวมงานบุคลากร",
    "link": "/hr/dashboard",
    "icon": "ri-dashboard-2-line"
  },
  {
    "label": "ทะเบียนประวัติบุคลากร",
    "link": "/hr/staff",
    "icon": "ri-team-line"
  },
  {
    "label": "อนุมัติการลา",
    "link": "/hr/leave-approval",
    "icon": "ri-calendar-check-line"
  },
  {
    "label": "อนุมัติออกนอกสถานที่",
    "link": "/hr/offsite-approval",
    "icon": "ri-walk-line"
  },
  {
    "label": "อนุมัติไปอบรม/ประชุม/กิจกรรม",
    "link": "/hr/training-approval",
    "icon": "ri-presentation-line"
  },
  {
    "label": "การเข้าสอนของครู",
    "link": "/hr/teaching-attendance",
    "icon": "ri-calendar-check-line"
  },
  {
    "label": "ครูไม่อยู่ / การจัดสอนแทน",
    "link": "/academic/teachers-on-leave",
    "icon": "ri-user-unfollow-line"
  },
  {
    "label": "ประเภทการลา",
    "link": "/hr/leave-types",
    "icon": "ri-list-settings-line"
  },
  {
    "label": "รายงานสรุปการลา",
    "link": "/hr/leave-report",
    "icon": "ri-bar-chart-box-line"
  }
]

// เมนูบุคลากร self-service — ทุกคนที่ล็อกอินเข้าถึงได้
const hrSelfMenu = [
  { "label": "ประวัติของฉัน", "link": "/hr/my-profile", "icon": "ri-profile-line" },
  { "label": "การลาของฉัน",   "link": "/hr/my-leave",   "icon": "ri-calendar-check-line" },
  { "label": "ขอออกนอกสถานที่", "link": "/hr/my-offsite", "icon": "ri-walk-line" },
  { "label": "แจ้งไปอบรม/ประชุม/กิจกรรม", "link": "/hr/my-training", "icon": "ri-presentation-line" },
]

// เมนูงานธุรการ (Admin Office pos 23, admin 99)
const adminOfficeMenu = [
  {
    "label": "ภาพรวมงานธุรการ",
    "link": "/admin-office/dashboard",
    "icon": "ri-dashboard-2-line"
  },
  {
    "label": "ทะเบียนหนังสือรับ",
    "link": "/admin-office/incoming",
    "icon": "ri-inbox-archive-line"
  },
  {
    "label": "ทะเบียนหนังสือส่ง",
    "link": "/admin-office/outgoing",
    "icon": "ri-send-plane-line"
  },
  {
    "label": "รับเรื่อง / เสนอแฟ้ม",
    "link": "/admin-office/memos",
    "icon": "ri-folder-received-line"
  },
  {
    "label": "คำสั่ง / ประกาศ",
    "link": "/admin-office/orders",
    "icon": "ri-megaphone-line"
  },
  {
    "label": "หนังสือรับรอง",
    "link": "/admin-office/certificates",
    "icon": "ri-award-line"
  },
  {
    "label": "งานประชุม",
    "link": "/admin-office/meetings",
    "icon": "ri-team-line"
  },
  {
    "label": "ติดตามมติที่ประชุม",
    "link": "/admin-office/resolutions",
    "icon": "ri-task-line"
  },
  {
    "label": "อนุมัติการจองห้อง/รถ",
    "link": "/admin-office/booking-approval",
    "icon": "ri-calendar-check-line"
  },
  {
    "label": "จัดการห้องประชุม/รถ",
    "link": "/admin-office/resources",
    "icon": "ri-building-line"
  },
  {
    "label": "แผนงาน / โครงการ",
    "link": "/admin-office/projects",
    "icon": "ri-bar-chart-box-line"
  },
  {
    "label": "สรุปผลงานประจำปี",
    "link": "/admin-office/annual-summary",
    "icon": "ri-file-chart-line"
  },
  {
    "label": "จดหมายเหตุรายวัน",
    "link": "/admin-office/daily-log",
    "icon": "ri-booklet-line"
  },
  {
    "label": "แฟ้มเอกสารสำคัญ",
    "link": "/admin-office/archive",
    "icon": "ri-safe-2-line"
  }
]

// เมนูงานธุรการ self-service — ทุกคนที่ล็อกอินเข้าถึงได้
const adminOfficeSelfMenu = [
  { "label": "หนังสือเวียนถึงฉัน", "link": "/my/received-docs", "icon": "ri-mail-open-line" },
  { "label": "บันทึกข้อความของฉัน", "link": "/my/memos", "icon": "ri-draft-line" },
  { "label": "คำสั่ง/ประกาศของฉัน", "link": "/my/orders", "icon": "ri-file-list-3-line" },
  { "label": "จองห้องประชุม/รถ", "link": "/my/booking", "icon": "ri-calendar-check-line" },
  { "label": "การประชุม/มติของฉัน", "link": "/my/meetings", "icon": "ri-team-line" },
  { "label": "โครงการของฉัน", "link": "/my/projects", "icon": "ri-bar-chart-box-line" },
]

// เมนูสำหรับหัวหน้าวิชการสามัญ
const disciplineMenu = [
  {
    "label": "ติดตามนักเรียนขาดเรียน",
    "link": "/discipline/absence-monitor",
    "icon": "ri-user-search-line"
  },
  {
    "label": "แจ้งลานักเรียน",
    "link": "/discipline/student-leave",
    "icon": "ri-calendar-close-line"
  },
  {
    "label": "ระบบติดตามนักเรียน",
    "link": "/academic/student-tracking",
    "icon": "ri-radar-line"
  },
  {
    "label": "คะแนนความประพฤติ",
    "link": "/discipline/conduct",
    "icon": "ri-shield-user-line"
  },
  {
    "label": "รายการความผิด",
    "link": "/discipline/conduct-rules",
    "icon": "ri-list-check-2"
  },
  {
    "label": "อนุญาตกลับบ้าน",
    "link": "/discipline/home-leave",
    "icon": "ri-home-heart-line"
  }
]

const headOfGeneralAcademicMenu = [
  {
    "label": "รายงานการเข้าเรียนวันนี้",
    "link": "/academic/general-attendance-report",
    "icon": "ri-file-text-line"
  }
  ,
  {
    "label": "รายงานการเข้าเรียนย้อนหลัง",
    "link": "/academic/attendance-history-report",
    "icon": "ri-history-line"
  },
  {
    "label": "ตรวจสอบผลการเรียนรายบุคคล",
    "link": "/academic/student-grade-review",
    "icon": "ri-file-search-line"
  },
  {
    "label": "รายงานการส่งเกรด",
    "link": "/academic/grade-submission-report",
    "icon": "ri-file-list-3-line"
  },
  {
    "label": "รายงานการส่งงานนักเรียน",
    "link": "/academic/assignment-submission-report",
    "icon": "ri-task-line"
  },
  {
    "label": "ครูไม่อยู่ / การจัดสอนแทน",
    "link": "/academic/teachers-on-leave",
    "icon": "ri-user-unfollow-line"
  },
  {
    "label": "ครูไปอบรม/ประชุม/กิจกรรม",
    "link": "/academic/teachers-on-training",
    "icon": "ri-presentation-line"
  },
  {
    "label": "การสอนแทน",
    "link": "/academic/substitute-overview",
    "icon": "ri-user-shared-line"
  },
  {
    "label": "ติดตามการเข้าเรียนรายนักเรียน",
    "link": "/academic/attendance-tracking",
    "icon": "ri-user-follow-line"
  },
  {
    "label": "นักเรียนที่ลา",
    "link": "/academic/students-on-leave",
    "icon": "ri-user-unfollow-line"
  },
  {
    "label": "การเข้าเรียน/บันทึกการสอน รายห้อง",
    "link": "/academic/attendance-by-room",
    "icon": "ri-government-line"
  },
  {
    "label": "ติดตามการเข้าสอน",
    "link": "/academic/teaching-entry-monitor",
    "icon": "ri-calendar-check-line"
  },
  {
    "label": "การเข้าสอนของครู",
    "link": "/hr/teaching-attendance",
    "icon": "ri-calendar-check-line"
  },
  {
    "label": "บันทึกการสอนรายครู",
    "link": "/academic/teaching-records-by-teacher",
    "icon": "ri-book-marked-line"
  },
  {
    "label": "รายชื่อนักเรียนรายห้อง",
    "link": "/academic/student-list-by-room",
    "icon": "ri-team-line"
  },
  {
    "label": "ติดตามงานครูประจำชั้น",
    "link": "/academic/advisor-task-tracking",
    "icon": "ri-user-star-line"
  },
  {
    "label": "ระบบติดตามนักเรียน",
    "link": "/academic/student-tracking",
    "icon": "ri-radar-line"
  },
  {
    "label": "จุดเด่นด้านการเรียน",
    "link": "/academic/student-talent",
    "icon": "ri-medal-line"
  }
]

// หัวหน้าระดับชั้น (ม.ต้น = pos 21 / ม.ปลาย = pos 22). ใช้หน้าเดียวกับหัวหน้าวิชาการ
// แต่ backend กรองข้อมูลให้เห็นเฉพาะระดับของตนเอง (ดู authController.attachLevelScope)
const levelHeadMenu = [
  {
    "label": "รายงานการเข้าเรียนวันนี้",
    "link": "/academic/general-attendance-report",
    "icon": "ri-file-text-line"
  },
  {
    "label": "รายงานการเข้าเรียนย้อนหลัง",
    "link": "/academic/attendance-history-report",
    "icon": "ri-history-line"
  },
  {
    "label": "ติดตามการเข้าเรียนกลุ่มเสี่ยง",
    "link": "/academic/attendance-tracking",
    "icon": "ri-user-follow-line"
  },
  {
    "label": "นักเรียนที่ลา",
    "link": "/academic/students-on-leave",
    "icon": "ri-user-unfollow-line"
  },
  {
    "label": "ระบบติดตามนักเรียน",
    "link": "/academic/student-tracking",
    "icon": "ri-radar-line"
  },
  {
    "label": "รายชื่อนักเรียนรายห้อง",
    "link": "/academic/student-list-by-room",
    "icon": "ri-team-line"
  }
]

//Menu from original Template
const dashboardMenu = [
  {
    "label": "สถิติของโรงเรียน",
    "link": "/dashboard/school-statistic",
    "icon": "ri-bar-chart-2-line"
  },
  {
    "label": "Finance Monitoring",
    "link": "/dashboard/finance",
    "icon": "ri-pie-chart-2-line"
  },
  {
    "label": "Events Management",
    "link": "/dashboard/events",
    "icon": "ri-calendar-todo-line"
  },
  {
    "label": "Sales Monitoring",
    "link": "/dashboard/sales",
    "icon": "ri-shopping-bag-3-line"
  },
  {
    "label": "Website Analytics",
    "link": "/dashboard/analytics",
    "icon": "ri-bar-chart-2-line"
  },
  {
    "label": "Cryptocurrency",
    "link": "/dashboard/crypto",
    "icon": "ri-coin-line"
  },
  {
    "label": "Helpdesk Service",
    "link": "/dashboard/helpdesk",
    "icon": "ri-service-line"
  },
  {
    "label": "Storage Management",
    "link": "/dashboard/storage",
    "icon": "ri-hard-drive-2-line"
  },
  {
    "label": "Product Management",
    "link": "/dashboard/product",
    "icon": "ri-suitcase-2-line"
  }
];

const applicationsMenu = [
  {
    "label": "File Manager",
    "link": "/apps/file-manager",
    "icon": "ri-folder-2-line"
  },
  {
    "label": "Email",
    "link": "/apps/email",
    "icon": "ri-mail-send-line"
  },
  {
    "label": "Calendar",
    "link": "/apps/calendar",
    "icon": "ri-calendar-line"
  },
  {
    "label": "Chat",
    "link": "/apps/chat",
    "icon": "ri-question-answer-line"
  },
  {
    "label": "Contacts",
    "link": "/apps/contacts",
    "icon": "ri-contacts-book-line"
  },
  {
    "label": "Task Manager",
    "link": "/apps/tasks",
    "icon": "ri-checkbox-multiple-line"
  },
  {
    "label": "Media Gallery",
    "icon": "ri-gallery-line",
    "submenu": [
      {
        "label": "Music Stream",
        "link": "/apps/gallery-music"
      },
      {
        "label": "Video Stream",
        "link": "/apps/gallery-video"
      }
    ]
  }
];

const pagesMenu = [
  {
    "label": "User Pages",
    "icon": "ri-account-circle-line",
    "submenu": [
      {
        "label": "User Profile",
        "link": "/pages/profile"
      },
      {
        "label": "People & Groups",
        "link": "/pages/people"
      },
      {
        "label": "Activity Log",
        "link": "/pages/activity"
      },
      {
        "label": "Events",
        "link": "/pages/events"
      },
      {
        "label": "Settings",
        "link": "/pages/settings"
      }
    ]
  },
  {
    "id": 27,
    "label": "Authentication",
    "icon": "ri-lock-2-line",
    "submenu": [
      {
        "label": "Sign In Basic",
        "link": "/pages/signin"
      },
      {
        "label": "Sign In Cover",
        "link": "/pages/signin2"
      },
      {
        "label": "Sign Up Basic",
        "link": "/pages/signup"
      },
      {
        "label": "Sign Up Cover",
        "link": "/pages/signup2"
      },
      {
        "label": "Verify Account",
        "link": "/pages/verify"
      },
      {
        "label": "Forgot Password",
        "link": "/pages/forgot"
      },
      {
        "label": "Lock Screen",
        "link": "/pages/lock"
      }
    ]
  },
  {
    "label": "Error Pages",
    "icon": "ri-error-warning-line",
    "submenu": [
      {
        "label": "Page Not Found",
        "link": "/pages/error-404"
      },
      {
        "label": "Internal Server Error",
        "link": "/pages/error-500"
      },
      {
        "label": "Service Unavailable",
        "link": "/pages/error-503"
      },
      {
        "label": "Forbidden",
        "link": "/pages/error-505"
      }
    ]
  },
  {
    "label": "Other Pages",
    "icon": "ri-file-text-line",
    "submenu": [
      {
        "label": "Pricing",
        "link": "/pages/pricing"
      },
      {
        "label": "FAQ",
        "link": "/pages/faq"
      }
    ]
  }
];

const uiElementsMenu = [
  {
    "label": "Getting Started",
    "icon": "ri-pencil-ruler-2-line",
    "submenu": [
      {
        "label": "Grid System",
        "link": "/docs/layout/grid"
      },
      {
        "label": "Columns",
        "link": "/docs/layout/columns"
      },
      {
        "label": "Gutters",
        "link": "/docs/layout/gutters"
      }
    ]
  },
  {
    "label": "Components",
    "icon": "ri-suitcase-line",
    "submenu": [
      {
        "label": "Accordion",
        "link": "/docs/com/accordions"
      },
      {
        "label": "Alerts",
        "link": "/docs/com/alerts"
      },
      {
        "label": "Avatars",
        "link": "/docs/com/avatars"
      },
      {
        "label": "Badge",
        "link": "/docs/com/badge"
      },
      {
        "label": "Breadcrumbs",
        "link": "/docs/com/breadcrumbs"
      },
      {
        "label": "Buttons",
        "link": "/docs/com/buttons"
      },
      {
        "label": "Cards",
        "link": "/docs/com/cards"
      },
      {
        "label": "Carousel",
        "link": "/docs/com/carousel"
      },
      {
        "label": "Dropdown",
        "link": "/docs/com/dropdown"
      },
      {
        "label": "Images",
        "link": "/docs/com/images"
      },
      {
        "label": "List Group",
        "link": "/docs/com/listgroup"
      },
      {
        "label": "Markers",
        "link": "/docs/com/markers"
      },
      {
        "label": "Modal",
        "link": "/docs/com/modal"
      },
      {
        "label": "Nav & Tabs",
        "link": "/docs/com/navtabs"
      },
      {
        "label": "Offcanvas",
        "link": "/docs/com/offcanvas"
      },
      {
        "label": "Pagination",
        "link": "/docs/com/pagination"
      },
      {
        "label": "Placeholders",
        "link": "/docs/com/placeholders"
      },
      {
        "label": "Popovers",
        "link": "/docs/com/popovers"
      },
      {
        "label": "Progress",
        "link": "/docs/com/progress"
      },
      {
        "label": "Spinners",
        "link": "/docs/com/spinners"
      },
      {
        "label": "Toast",
        "link": "/docs/com/toasts"
      },
      {
        "label": "Tooltips",
        "link": "/docs/com/tooltips"
      },
      {
        "label": "Tables",
        "link": "/docs/com/tables"
      }
    ]
  },
  {
    "label": "Forms",
    "icon": "ri-list-check-2",
    "submenu": [
      {
        "label": "Text Elements",
        "link": "/docs/form/elements"
      },
      {
        "label": "Selects",
        "link": "/docs/form/selects"
      },
      {
        "label": "Checks & Radios",
        "link": "/docs/form/checksradios"
      },
      {
        "label": "Range",
        "link": "/docs/form/range"
      },
      {
        "label": "Pickers",
        "link": "/docs/form/pickers"
      },
      {
        "label": "Layouts",
        "link": "/docs/form/layouts"
      }
    ]
  },
  {
    "label": "Charts & Graphs",
    "icon": "ri-bar-chart-2-line",
    "submenu": [
      {
        "label": "ApexCharts",
        "link": "/docs/chart/apex"
      },
      {
        "label": "Chartjs",
        "link": "/docs/chart/chartjs"
      }
    ]
  },
  {
    "label": "Maps & Icons",
    "icon": "ri-stack-line",
    "submenu": [
      {
        "label": "Leaflet Maps",
        "link": "/docs/map/leaflet"
      },
      {
        "label": "Vector Maps",
        "link": "/docs/map/vector"
      },
      {
        "label": "Remixicon",
        "link": "/docs/icon/remix"
      },
      {
        "label": "Feathericons",
        "link": "/docs/icon/feather"
      }
    ]
  },
  {
    "label": "Utilities",
    "icon": "ri-briefcase-4-line",
    "submenu": [
      {
        "label": "Background",
        "link": "/docs/util/background"
      },
      {
        "label": "Border",
        "link": "/docs/util/border"
      },
      {
        "label": "Colors",
        "link": "/docs/util/colors"
      },
      {
        "label": "Divider",
        "link": "/docs/util/divider"
      },
      {
        "label": "Flex",
        "link": "/docs/util/flex"
      },
      {
        "label": "Sizing",
        "link": "/docs/util/sizing"
      },
      {
        "label": "Spacing",
        "link": "/docs/util/spacing"
      },
      {
        "label": "Opacity",
        "link": "/docs/util/opacity"
      },
      {
        "label": "Position",
        "link": "/docs/util/position"
      },
      {
        "label": "Typography",
        "link": "/docs/util/typography"
      },
      {
        "label": "Shadows",
        "link": "/docs/util/shadows"
      },
      {
        "label": "Extras",
        "link": "/docs/util/extras"
      }
    ]
  }
];

const bankMenu = [
  {
    "label": "Dashboard ธนาคาร",
    "link": "/bank/dashboard",
    "icon": "ri-line-chart-line"
  },
  {
    "label": "บัญชีนักเรียน",
    "link": "/bank/accounts",
    "icon": "ri-bank-card-line"
  },
  {
    "label": "บันทึกรายการ",
    "link": "/bank/transactions",
    "icon": "ri-exchange-funds-line"
  }
];

const inventoryMenu = [
  {
    "label": "Dashboard พัสดุ",
    "link": "/inventory/dashboard",
    "icon": "ri-dashboard-3-line"
  },
  {
    "label": "ทะเบียนครุภัณฑ์",
    "link": "/inventory/assets",
    "icon": "ri-archive-line"
  },
  {
    "label": "ขอจัดซื้อ/จัดจ้าง",
    "link": "/inventory/procurement",
    "icon": "ri-shopping-cart-2-line"
  },
  {
    "label": "ผู้ขาย/คู่ค้า",
    "link": "/inventory/vendors",
    "icon": "ri-store-2-line"
  },
  {
    "label": "ตั้งค่าพัสดุ",
    "link": "/inventory/settings",
    "icon": "ri-database-2-line"
  }
];

// เมนูวัสดุและของใช้ (pos 19, 99)
const supplyMenu = [
  { "label": "Dashboard วัสดุ",   "link": "/supply/dashboard",    "icon": "ri-store-3-line" },
  { "label": "รายการวัสดุ",       "link": "/supply/items",         "icon": "ri-stack-line" },
  { "label": "รับเข้าคลัง",       "link": "/supply/receive",       "icon": "ri-download-2-line" },
  { "label": "เบิกวัสดุ",         "link": "/supply/requisitions",  "icon": "ri-file-list-3-line" },
  { "label": "ยืม-คืน",           "link": "/supply/borrow",        "icon": "ri-arrow-left-right-line" },
  { "label": "ตั้งค่าวัสดุ",      "link": "/supply/settings",      "icon": "ri-settings-3-line" },
];

// เมนูสำหรับครูผู้สอนภาคศาสนา (pos 50)
const islamicTeachingMenu = [
  {
    "label": "วิชาที่รับผิดชอบ",
    "labelJawi": "ماتا ڈلاجرن سايا",
    "link": "/islamic/my-subjects",
    "icon": "ri-artboard-line"
  },
  {
    "label": "เช็คชื่อนักเรียน",
    "labelJawi": "ڈريکسا ناما مريد",
    "link": "/islamic/attendance",
    "icon": "ri-checkbox-circle-line"
  }
];

// เมนูสำหรับวัดผลภาคศาสนา (pos 52, 54)
const islamicAssessmentMenu = [
  {
    "label": "ตารางคะแนนภาคศาสนา",
    "labelJawi": "جدول مرک باهاڬيان اڬام",
    "link": "/islamic/grades",
    "icon": "ri-grid-line"
  }
];

// เมนูสำหรับจัดการการสอนภาคศาสนา (pos 52)
const islamicManageTeachingMenu = [
  {
    "label": "จัดการผู้สอน",
    "labelJawi": "جدول ڤڠاجارن (ڬلوله)",
    "link": "/islamic/manage-teaching",
    "icon": "ri-user-settings-line"
  },
  {
    "label": "ติดตามการสอน",
    "labelJawi": "ڤنتاوان ڤڠاجارن",
    "link": "/islamic/teaching-tracking",
    "icon": "ri-survey-line"
  }
];

// เมนูสำหรับที่ปรึกษาห้องภาคศาสนา (pos 53)
const islamicAdvisorMenu = [
  {
    "label": "ห้องเรียนของฉัน",
    "labelJawi": "بيليک دارجه سايا",
    "link": "/islamic/advisor/home",
    "icon": "ri-home-heart-line"
  },
  {
    "label": "รายชื่อนักเรียน",
    "labelJawi": "سنارائي مريد",
    "link": "/islamic/advisor/students",
    "icon": "ri-user-3-line"
  },
  {
    "label": "คะแนน & การเข้าเรียน",
    "labelJawi": "مرک & ڤرهاديران",
    "link": "/islamic/advisor/grades",
    "icon": "ri-bar-chart-box-line"
  }
];

// เมนูสำหรับทะเบียนภาคศาสนา (pos 52)
const islamicRegistrationMenu = [
  {
    "label": "จัดการห้องเรียน",
    "labelJawi": "ڬلوله بيليک دارجه",
    "link": "/islamic/manage-rooms",
    "icon": "ri-building-2-line"
  },
  {
    "label": "จัดการนักเรียน",
    "labelJawi": "ڬلوله مريد",
    "link": "/islamic/manage-students/0",
    "icon": "ri-group-line"
  },
  {
    "label": "จัดการหลักสูตร",
    "labelJawi": "ڬلوله سيلابوس",
    "link": "/islamic/manage-curriculum",
    "icon": "ri-book-2-line"
  }
];

// เมนูข้อมูลนักเรียน — ทุกคนที่ล็อกอินเข้าถึงได้
const studentSearchMenu = [
  { "label": "ค้นหาข้อมูลนักเรียน", "link": "/students/search", "icon": "ri-user-search-line" },
];

// เมนูทั่วไป — ทุกคนที่ล็อกอินเข้าถึงได้
const generalMenu = [
  { "label": "ดาวน์โหลดเอกสาร", "link": "/general/documents",     "icon": "ri-folder-download-line" },
  { "label": "ประกาศ/ข่าวสาร",  "link": "/general/announcements", "icon": "ri-pushpin-line" },
  { "label": "ปฏิทินการศึกษา",  "link": "/general/calendar",      "icon": "ri-calendar-event-line" },
  { "label": "คู่มือ/ติดต่อ",    "link": "/general/help",          "icon": "ri-question-line" },
];

// เมนูแจ้งปัญหา / แจ้งซ่อม — ทุกคนที่ล็อกอินเข้าถึงได้ (Inbox ใช้ได้เฉพาะหัวหน้าฝ่าย/admin)
const issueReportingMenu = [
  { "label": "แจ้งปัญหา / แจ้งซ่อม", "link": "/issues/submit", "icon": "ri-tools-fill" },
  { "label": "รายการที่ฉันแจ้ง",     "link": "/issues/mine",   "icon": "ri-file-list-3-line" },
  { "label": "กล่องรับเรื่อง (ฝ่าย)", "link": "/issues/inbox",  "icon": "ri-inbox-line" },
];

// เมนูจัดการระบบแจ้งปัญหา (admin pos 99)
const issueReportingAdminMenu = [
  { "label": "ประเภทปัญหา",   "link": "/issues/admin/categories", "icon": "ri-list-settings-line" },
  { "label": "หัวหน้าฝ่าย",   "link": "/issues/admin/dept-heads", "icon": "ri-team-line" },
];

export {
  adminMenu,
  executiveMenu,
  teachingMenu,
  studentSearchMenu,
  generalMenu,
  issueReportingMenu,
  issueReportingAdminMenu,
  advisorMenu,
  manageTeachingMenu,
  registrationMenu,
  assessmentMenu,
  headOfGeneralAcademicMenu,
  levelHeadMenu,
  libraryMenu,
  dormitoryMenu,
  disciplineMenu,
  bankMenu,
  feeMenu,
  hrMenu,
  hrSelfMenu,
  adminOfficeMenu,
  adminOfficeSelfMenu,
  inventoryMenu,
  supplyMenu,
  dashboardMenu,
  applicationsMenu,
  pagesMenu,
  uiElementsMenu,
  islamicRegistrationMenu,
  islamicTeachingMenu,
  islamicAssessmentMenu,
  islamicAdvisorMenu,
  islamicManageTeachingMenu,
};
